import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24.237,
	height: 26.5,
	viewBox: "0 0 24.237 26.5",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{isolation:isolate;}.b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-86 168.25)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				className: "a",
				transform: "translate(103.171 -167.5)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "b",
					d: "M1.125,0V9",
					transform: "translate(-1.125)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "a",
				transform: "translate(93.066 -167.5)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "b",
					d: "M1.125,0V9",
					transform: "translate(-1.125)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "a",
				transform: "translate(86.75 -157.658)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "b",
					d: "M0,1.125H22.737",
					transform: "translate(0 -1.125)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "a",
				transform: "translate(86.75 -162)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "b",
					d: "M20.211,0H2.526A2.418,2.418,0,0,0,0,2.294V17.206A2.418,2.418,0,0,0,2.526,19.5H20.211a2.418,2.418,0,0,0,2.526-2.294V2.294A2.418,2.418,0,0,0,20.211,0Z"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "a",
				transform: "translate(86.868 -152.605)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "b",
					d: "M0,1.125H22.5",
					transform: "translate(0 -1.125)"
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				className: "a",
				transform: "translate(90.284 -147.553)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "b",
					d: "M0,1.125H11.25",
					transform: "translate(0 -1.125)"
				})
			})
		]
	})]
});
export default SvgCalendar2;
